(() => {
  const cfg = (() => {
    if (window.GWP_CONFIG && typeof window.GWP_CONFIG === "object") return window.GWP_CONFIG;
    const el = document.getElementById("GwpConfig");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (_) {
      return {};
    }
  })();
  if (!cfg.enabled) return;

  const variantId = Number.parseInt(String(cfg.variantId || "").trim(), 10);
  if (!Number.isFinite(variantId) || variantId <= 0) return;

  const LINE_ITEM_PROP = cfg.lineItemProperty || "_gwp_gift";
  const SOURCE = "gwp-auto-add";
  const CART_UPDATE_EVENT =
    (typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS?.cartUpdate) ||
    window.PUB_SUB_EVENTS?.cartUpdate;

  let inFlight = false;
  let queued = false;
  let lastSignature = null;
  let lastHadGift = false;

  const optOutStorageKey = `gwp_opt_out_v1:${variantId}`;

  const isOptedOut = () => {
    try {
      return window.sessionStorage?.getItem(optOutStorageKey) === "1";
    } catch (_) {
      return false;
    }
  };

  const setOptedOut = () => {
    try {
      window.sessionStorage?.setItem(optOutStorageKey, "1");
    } catch (_) {}
  };

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const cartJsUrl = `${root}cart.js`;
  const addUrl = (window.routes && window.routes.cart_add_url) || `${root}cart/add`;
  const changeUrl = (window.routes && window.routes.cart_change_url) || `${root}cart/change`;
  const SECTIONS_TO_RENDER = ["cart-icon-bubble", "cart-bundle-progress", "cart-drawer"];

  const postJson = async (url, payload) => {
    const config =
      typeof fetchConfig === "function"
        ? { ...fetchConfig("json"), body: JSON.stringify(payload) }
        : {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          };

    const res = await fetch(url, config);
    if (!res.ok) throw new Error(`GWP request failed: ${res.status}`);
    return res.json().catch(() => null);
  };

  const fetchCart = async () => {
    const res = await fetch(cartJsUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
    return res.json();
  };

  const isGiftItem = (item) => {
    const props = item && item.properties;
    if (!props) return false;
    const v = props[LINE_ITEM_PROP];
    return v === true || v === "true" || v === 1 || v === "1";
  };

  const signatureForCart = (cart) => {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    return items
      .map((i) => `${i.key}:${i.quantity}:${isGiftItem(i) ? "g" : "n"}`)
      .join("|");
  };

  const getSectionInnerHTML = (html, selector) => {
    try {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || "";
    } catch (_) {
      return "";
    }
  };

  const renderSections = (sections) => {
    if (!sections) return;
    const cartDrawerHtml = sections["cart-drawer"];
    if (cartDrawerHtml) {
      const drawerRoot = document.querySelector("#CartDrawer");
      if (drawerRoot) {
        drawerRoot.innerHTML = getSectionInnerHTML(cartDrawerHtml, "#CartDrawer") || drawerRoot.innerHTML;
      }
    }
    for (const sectionId of SECTIONS_TO_RENDER) {
      if (sectionId === "cart-drawer") continue;
      const sectionHtml = sections[sectionId];
      if (!sectionHtml) continue;
      const container = document.getElementById(sectionId);
      if (!container) continue;
      const target = container.querySelector(".shopify-section") || container;
      target.innerHTML = getSectionInnerHTML(sectionHtml, ".shopify-section") || sectionHtml;
    }
  };

  const applyEmptyState = (itemCount) => {
    const isEmpty = Number(itemCount) === 0;
    const drawer = document.querySelector("cart-drawer");
    if (drawer) drawer.classList.toggle("is-empty", isEmpty);
    const drawerItems = document.querySelector("cart-drawer-items");
    if (drawerItems) drawerItems.classList.toggle("is-empty", isEmpty);
    const footer = document.getElementById("main-cart-footer");
    if (footer) footer.classList.toggle("is-empty", isEmpty);
  };

  const publishCartUpdate = (cart) => {
    try {
      if (typeof publish === "function" && CART_UPDATE_EVENT) {
        publish(CART_UPDATE_EVENT, cart ? { source: SOURCE, cartData: cart } : { source: SOURCE });
      }
    } catch (_) {}

    try {
      document.dispatchEvent(new CustomEvent("cart:ui:updated", { detail: { source: SOURCE, cart } }));
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: SOURCE, cart } }));
    } catch (_) {}
  };

  const reconcile = async () => {
    if (inFlight) {
      queued = true;
      return;
    }
    inFlight = true;

    try {
      const cart = await fetchCart();
      const sig = signatureForCart(cart);
      if (sig === lastSignature) return;
      lastSignature = sig;

      const items = cart.items || [];
      const qualifyingExists = items.some((i) => !isGiftItem(i));
      const giftLine = items.find((i) => Number(i.id) === variantId && isGiftItem(i));
      const hasGiftNow = Boolean(giftLine);

      // If the cart still qualifies but the gift disappeared, treat that as a customer opting out
      // (so we don't re-add it for the remainder of this browser session).
      if (!hasGiftNow && lastHadGift && qualifyingExists) {
        setOptedOut();
      }

      // Keep memory for the next pass
      lastHadGift = hasGiftNow;

      // Respect session opt-out
      if (isOptedOut()) return;

      if (qualifyingExists) {
        if (!giftLine) {
          const addRes = await postJson(addUrl, {
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: { [LINE_ITEM_PROP]: "true" },
              },
            ],
            sections: SECTIONS_TO_RENDER,
            sections_url: window.location.pathname,
          });
          renderSections(addRes?.sections);
          lastSignature = null;
          publishCartUpdate(null);
        } else if (giftLine.quantity !== 1) {
          const nextCart = await postJson(changeUrl, {
            id: giftLine.key,
            quantity: 1,
            sections: SECTIONS_TO_RENDER,
            sections_url: window.location.pathname,
          });
          lastSignature = signatureForCart(nextCart);
          renderSections(nextCart?.sections);
          applyEmptyState(nextCart?.item_count);
          publishCartUpdate(nextCart);
        }
      } else if (giftLine) {
        const nextCart = await postJson(changeUrl, {
          id: giftLine.key,
          quantity: 0,
          sections: SECTIONS_TO_RENDER,
          sections_url: window.location.pathname,
        });
        lastSignature = signatureForCart(nextCart);
        renderSections(nextCart?.sections);
        applyEmptyState(nextCart?.item_count);
        publishCartUpdate(nextCart);
      }
    } catch (err) {
      // Keep silent in production; avoid breaking cart flows.
      // console.warn("[GWP]", err);
    } finally {
      inFlight = false;
      if (queued) {
        queued = false;
        setTimeout(reconcile, 0);
      }
    }
  };

  const schedule = (() => {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(reconcile, 0);
    };
  })();

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => schedule(), { once: true });
  } else {
    schedule();
  }

  // Theme-native cart update events
  try {
    if (typeof subscribe === "function" && CART_UPDATE_EVENT) {
      subscribe(CART_UPDATE_EVENT, (event) => {
        if (event?.source === SOURCE) return;
        schedule();
      });
    }
  } catch (_) {}

  // Custom events already used in this theme
  document.addEventListener("cart:ui:updated", () => schedule());
  document.addEventListener("cart:addtocart_complete", () => schedule());
})();